export const en = {
    "action-unpublish": "Unpublish",
    "action-publish-version": "Publish version",
    "status-unpublished": "Unpublished",
    "unpublish-confirm-title": "Unpublish agent?",
    "unpublish-confirm-text": "The agent will become unavailable to users, but the published version will remain in the system.",
    "toast-unpublished": "Unpublished",
    "toast-unpublish-error": "Failed to unpublish",
    "toast-published-version": "Version published",
    "toast-publish-version-error": "Failed to publish version",
    "toast-refresh-error": "Action completed, but failed to refresh data"
} as const;

export const ru = {
    "action-unpublish": "Снять с публикации",
    "action-publish-version": "Опубликовать версию",
    "status-unpublished": "Снято с публикации",
    "unpublish-confirm-title": "Снять агента с публикации?",
    "unpublish-confirm-text": "Агент станет недоступен пользователям, но опубликованная версия останется в системе.",
    "toast-unpublished": "Снято с публикации",
    "toast-unpublish-error": "Не удалось снять с публикации",
    "toast-published-version": "Версия опубликована",
    "toast-publish-version-error": "Не удалось опубликовать версию",
    "toast-refresh-error": "Действие выполнено, но не удалось обновить данные"
} as const;
